var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-list-item-actions',{attrs:{"id":"group-more-action-dropdown","group":_vm.group},on:{"action":_vm.handleAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }